import React from "react";
import { useNavigate } from "react-router-dom";
import { MenuSheet } from "./MenuSheet.jsx";

const MenuButton = (props) => {
  const navigate = useNavigate();
  const goTo = (section) => {
    navigate("/");

    try {
      const element = document.querySelector(`#` + section);
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    } catch (e) {}
  };

  return (
    <div className="menu-button sticky flex-1 top-0 gap-5 xl:gap-20 xl:flex-grow xl:order-2 xl:justify-center ">
      <MenuSheet goTo={goTo} className="flex xl:hidden" />
      <div
        className="hidden xl:block text-[24px] font-[500] font-Bebas cursor-pointer"
        onClick={(e) => goTo("inicio")}
      >
        {" "}
        Inicio{" "}
      </div>
      <div
        className="hidden xl:block text-[24px] font-[500]  font-Bebas cursor-pointer"
        onClick={(e) => goTo("especiales")}
      >
        {" "}
        Especiales{" "}
      </div>
      <div
        className="hidden xl:block text-[24px] font-[500]  font-Bebas cursor-pointer"
        onClick={() => goTo("about")}
      >
        {" "}
        Sobre Nosotros{" "}
      </div>
      <div
        href="/#contact"
        className="hidden xl:block text-[24px] font-[500]  font-Bebas"
        onClick={() => goTo("contact")}
      >
        {" "}
        Contactanos{" "}
      </div>
    </div>
  );
};

export default MenuButton;
